import Backend from 'shared/lib/Backend';
import debouncedSaveTemplate from "fantastic/lib/debouncedSaveTemplate";

export default (id, file, attrs) => async (dispatch, getState) => {
  const body = new FormData();
  body.append('file', file, file.name);
  const url = `${window.location.pathname}/${getState().settings.upload_item_image}`;
  const response = await Backend.post(url, { body });
  if(response.result === 'success') {
    const data = { alt: file.name, src: response.src, ...attrs };
    dispatch({ type: "SECTIONS/UPDATE", payload: { id, data } });
    debouncedSaveTemplate(dispatch, getState);
  } else if(response.result === 'fail') {
    dispatch({ type: "FAIL", payload: response.messages[0] });
  }
};
